import qvctSurvey from "./modules/qvctSurvey"
import qvctCategories from "./modules/qvctCategorie"
import qvctCategoriesType from "./modules/qvctCategorie"
import qvctPopulation from "./modules/qvctPopulation"
import qvctSurveyStatus from "./modules/qvctSurvey"
import qvctAnswersType from "./modules/qvctAnswerType"
import qvctAnswersChoise from "./modules/qvctAnswerChoice"
import qvctAnswerMark from "./modules/qvctAnswerMark"
import qvctSurveysReport from "./modules/qvctReport";
export default {
    modules: {
        qvctSurvey,
        qvctCategories,
        qvctCategoriesType,
        qvctPopulation,
        qvctSurveyStatus,
        qvctAnswersType,
        qvctAnswersChoise,
        qvctAnswerMark,
        qvctSurveysReport
    }
}
